import React from 'react';

export function PlayerListItem ({ player : { image, name, details  } }) {
    return  (<img src={image} alt={name}  data-player={JSON.stringify(details)}  className="playerImage" />);
}



